/* eslint-disable no-console */
import { Children, cloneElement, FC, isValidElement, ReactNode } from 'react';
import { useDispatch } from 'react-redux';

import { getActiveAccount, login } from '@lib/beacon';
import { actions } from '@state/auth';
import { testNodeHealth } from '@utils/node';

interface IAuthDecorator {
  children?: ReactNode;
  onClick?: () => void;
}

export const AuthDecorator: FC<IAuthDecorator> = ({ children, onClick = () => null }) => {
  const dispatch = useDispatch();

  const handleClick = async () => {
    await testNodeHealth();
    const account = await getActiveAccount();

    if (!account) {
      const response = await login();
      dispatch({ type: actions.AUTH_LOGIN, payload: response });
    }

    if (onClick) {
      onClick();
    }
  };

  const childrenWithProps = Children.map(children, (child) => {
    if (isValidElement(child)) {
      return cloneElement(child, { onClick: handleClick });
    }
    return child;
  });

  return <div>{childrenWithProps}</div>;
};
